// Componente para exibir a disponibilidade semanal da babá em formato de calendário
import React, { useMemo } from "react";

const CELL_ON = {
  manha:    { wrapper: "bg-amber-50 border-amber-400",    dot: "bg-amber-400" },
  tarde:    { wrapper: "bg-rose-50 border-rose-400",      dot: "bg-rose-400" },
  noite:    { wrapper: "bg-slate-blue-400/10 border-slate-blue-400", dot: "bg-slate-blue-400" },
  pernoite: { wrapper: "bg-gray-100 border-gray-400",     dot: "bg-gray-500" },
};

export default function CalendarioDisponibilidade({ disponibilidade }) {
  const dias = [
    "segunda",
    "terca",
    "quarta",
    "quinta",
    "sexta",
    "sabado",
    "domingo",
  ];

  const diasAbreviados = {
    segunda: "Seg",
    terca: "Ter",
    quarta: "Qua",
    quinta: "Qui",
    sexta: "Sex",
    sabado: "Sáb",
    domingo: "Dom",
  };

  const periodos = ["manha", "tarde", "noite", "pernoite"];

  const labelsPeriodos = {
    manha: "Manhã",
    tarde: "Tarde",
    noite: "Noite",
    pernoite: "Pernoite",
  };

  // garante que sempre exista estrutura completa
  const getSafeDisponibilidade = useMemo(() => {
    let rawDisp = disponibilidade;

    // Caso o dado venha como string do Supabase (comum em views complexas)
    if (typeof disponibilidade === "string") {
      try {
        rawDisp = JSON.parse(disponibilidade);
      } catch (e) {
        rawDisp = {};
      }
    }

    return dias.reduce((acc, dia) => {
      acc[dia] = {
        manha: false,
        tarde: false,
        noite: false,
        pernoite: false,
        ...(rawDisp?.[dia] || {}),
      };
      return acc;
    }, {});
  }, [disponibilidade, dias]);

  return (
    <div className="rounded-2xl border border-warm-200 bg-white p-5 font-body">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <span className="text-[13px] font-medium uppercase tracking-wide text-warm-500">
          Disponibilidade Semanal
        </span>
        <div className="flex items-center gap-3.5 text-xs text-warm-400">
          <div className="flex items-center gap-1.5">
            <span className="inline-block h-2.5 w-2.5 shrink-0 rounded-full bg-slate-blue-400" />
            Disponível
          </div>
          <div className="flex items-center gap-1.5">
            <span className="inline-block h-2.5 w-2.5 shrink-0 rounded-full border border-warm-300 bg-transparent" />
            Indisponível
          </div>
        </div>
      </div>

      {/* Tabela */}
      <div className="overflow-x-auto">
        <table className="w-full border-separate" style={{ borderSpacing: "5px" }}>
          <thead>
            <tr>
              <th className="min-w-[80px] pb-2 text-left text-[13px] font-medium text-warm-500">
                Período
              </th>
              {dias.map((dia) => (
                <th key={dia} className="pb-2 text-center text-[13px] font-medium text-warm-500">
                  {diasAbreviados[dia]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {periodos.map((periodo) => (
              <tr key={periodo}>
                <th className="py-1 text-left text-[12px] font-medium whitespace-nowrap text-warm-400">
                  {labelsPeriodos[periodo]}
                </th>
                {dias.map((dia) => {
                  const disponivel = getSafeDisponibilidade[dia]?.[periodo];
                  const on = disponivel && CELL_ON[periodo];
                  return (
                    <td key={`${dia}-${periodo}`} className="p-0 text-center">
                      <div
                        className={[
                          "mx-auto flex aspect-square min-h-8 min-w-8 items-center justify-center rounded-[10px] border-[1.5px] transition-colors duration-150",
                          on
                            ? on.wrapper
                            : "border-warm-200 bg-warm-50",
                        ].join(" ")}
                      >
                        {on && (
                          <span
                            className={`inline-block h-[9px] w-[9px] shrink-0 rounded-full ${on.dot}`}
                          />
                        )}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
